import { Permission } from './analytics.types';

export const PERMISSION_TO_USER_TYPE: Record<Permission, string> = {
  [Permission.ADMIN]: 'Sidehub Admin',
  [Permission.ASSET_FINDER]: 'Asset Finder',
  [Permission.TRAY_ASSEMBLER]: 'SPD Technician',
  [Permission.OR_ASSIGN]: 'OR Team',
  [Permission.SPD_RELEASE]: 'SPD Release',
};

// Explicit priority for multi-permission users — highest index wins.
// Confirm order with product if requirements change.
export const PERMISSION_PRIORITY: Permission[] = [
  Permission.ASSET_FINDER,
  Permission.OR_ASSIGN,
  Permission.SPD_RELEASE,
  Permission.TRAY_ASSEMBLER,
];

export const PERI_TRAY_VIEWS = {
  SELECT_TRAY: 'select-tray',
  SCAN_INSTRUMENTS: 'scan-instruments',
  ASSEMBLY_COMPLETION: 'assembly-completion',
} as const;

// Event names are short action-only strings (e.g. 'cancelClicked').
// Page context is passed separately via the child_view custom dimension in trackEvent params.
// Restart modal events retain the restartModal/ prefix to distinguish from same-named nav actions.
export const PERI_TRAY_EVENTS = {
  // --- Select Tray page (select-tray) ---
  BARCODE_SCANNED: 'barcodeScanned',
  NO_MATCHING_RESULTS: 'noMatchingResults',
  VIEW_CLICKED: 'viewClicked',
  BUILD_CLICKED: 'buildClicked',
  ERROR_PAGE_LOAD_FAILED: 'errorPageLoadFailed',
  TRY_AGAIN_CLICKED: 'tryAgainClicked',
  START_OVER_CLICKED: 'startOverClicked',

  // --- Scan Instruments page (scan-instruments) ---
  ERROR_TRAY_IN_USE: 'errorTrayInUse',

  // Primary Nav
  RESTART_TRAY_CLICKED: 'restartTrayClicked',
  CANCEL_CLICKED: 'cancelClicked',
  MARK_AS_COMPLETE_CLICKED: 'markAsCompleteClicked',

  // Restart Modal
  RESTART_MODAL_CANCEL_CLICKED: 'restartModal/cancelClicked',
  RESTART_MODAL_CONFIRM_CLICKED: 'restartModal/restartTrayClicked',
  RESTART_MODAL_X_CLICKED: 'restartModal/xClicked',
  TRAY_RESET_CONFIRMED: 'trayResetConfirmed',

  // Camera
  CAMERA_OFF_CLICKED: 'cameraOffClicked',
  CAMERA_ON_CLICKED: 'cameraOnClicked',
  ERROR_CAMERA_DISCONNECTED: 'errorCameraDisconnected',

  // CV Detection
  CORRECT_DETECTED: 'correctDetected',
  CORRECT_AUTO_COUNTED: 'correctAutoCounted',
  INCORRECT_DETECTED: 'incorrectDetected',
  UNCERTAIN_DETECTED: 'uncertainDetected',
  DETECTED_3: 'detected3',
  DETECTED_6: 'detected6',
  DETECTED_9: 'detected9',
  DETECTED_12: 'detected12',
  DETECTED_15: 'detected15',

  // Card Interactions
  INCORRECT_NOT_ADDED_CLICKED: 'incorrectNotAddedClicked',
  UNCERTAIN_CONFIRM_CLICKED: 'uncertainConfirmClicked',
  UNCERTAIN_NOT_ADDED_CLICKED: 'uncertainNotAddedClicked',
  INCORRECT_MARK_AS_ADDON_CLICKED: 'incorrectMarkAsAddonClicked',
  CORRECT_OVERRIDE_CLICKED: 'correctOverrideClicked',
  INCORRECT_OVERRIDE_CLICKED: 'incorrectOverrideClicked',
  UNCERTAIN_OVERRIDE_CLICKED: 'uncertainOverrideClicked',

  // Manual Countsheet
  MANUAL_ADD_CLICKED: 'manualAddClicked',
  MANUAL_REMOVE_CLICKED: 'manualRemoveClicked',
  COUNTSHEET_SEARCH_CLICKED: 'searchClicked',

  // Override Drawer (page view vs event — to be confirmed with team)
  OVERRIDE_DRAWER_DISPLAYED: 'overrideDrawerDisplayed',
  OVERRIDE_SEARCH_RESULT_SELECTED: 'searchResultSelected',
  OVERRIDE_CONFIRM_CLICKED: 'confirmClicked',

  // Mark as Addon (page view vs event — to be confirmed with team)
  MARK_AS_ADDON_MODAL_DISPLAYED: 'markAsAddonModalDisplayed',
  MARK_AS_ADDON_CONFIRMED: 'markAsAddonConfirmed',
  MANUAL_ADD_ON_REMOVE_CLICKED: 'manualAddOnRemoveClicked',

  // --- Assembly Completion page (assembly-completion) ---
  ASSEMBLY_MARK_AS_COMPLETE_CLICKED: 'markAsCompleteClicked',
  ASSEMBLY_BACK_CLICKED: 'backClicked',
  CAPTURE_PHOTO_CLICKED: 'capturePhotoClicked',
  RETAKE_PHOTO_CLICKED: 'retakePhotoClicked',
  MODAL_IMAGE_CLICKED: 'modalImageClicked',
  DONE_CLICKED: 'doneClicked',
} as const;
